import { getInitialViewState } from 'components/map/location/defaultMapLocation';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { CustomActionButton } from 'pages/custom/shared/CustomHeader/CustomActionButton';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ExtremeButtons = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const isWide = useIsWide();
    const ctxView = useContext(CtxView);

    function showContent(setId: string) {
        const oneSetStoryIds = ctxView.allMarkers
            .filter((marker) => marker.worldMapSets.some((set) => set.worldMapSetId === setId))
            .flatMap((e) => e.stories.map((story) => story.storyId))
            .filter(Boolean);
        ctxModal.setDetailListModal({
            storyIds: oneSetStoryIds
        });
    }

    function actionResetZoom() {
        const initialMapPosition = getInitialViewState(ctxView.map, isWide);
        if (initialMapPosition.bounds) {
            ctxView.mapRef.current.fitBounds(initialMapPosition.bounds);
        } else {
            ctxView.mapRef.current.flyTo({
                zoom: initialMapPosition.zoom,
                center: [initialMapPosition.longitude, initialMapPosition.latitude]
            });
        }
    }

    return (
        <S_ExtremeButtons className={props.className}>
            <S_Button
                iconSet="far"
                iconName="book"
                text={'Areas'}
                onClick={() => {
                    showContent('35178bd6-b0c4-4eaf-961a-25956dfb6b7f');
                }}
            />
            <S_Button
                iconSet="far"
                iconName="utensils"
                text={'Restaurants'}
                onClick={() => {
                    showContent('115e94f2-203c-46a3-89d0-18f066f89c76');
                }}
            />
            <S_Button
                iconSet="far"
                iconName="bolt"
                text={'Activities'}
                onClick={() => {
                    showContent('84eb8222-b8e8-4fb6-92b8-dfecb1f89668');
                }}
            />
            <S_Button
                iconSet="far"
                iconName="frame"
                text={'Zoom'}
                onClick={(e) => {
                    actionResetZoom();
                    e.stopPropagation();
                }}
            />
        </S_ExtremeButtons>
    );
};

const S_ExtremeButtons = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 1259px) {
        width: unset;
    }
`;

const S_Button = styled(CustomActionButton)`
    width: 100%;
    @media only screen and (min-width: 1259px) {
        min-width: 150px;
        width: unset;
    }
`;
